const variants = {
  'on-primary-button': {
    bg: 'brand.100',
    color: 'brand.600',
    borderColor: 'brand.300',
  },
}

const defaultProps = {
  variant: undefined,
}

export default {
  variants,
  defaultProps,
}
